import {ComponentItems} from "./component-Items";
import {DynamicValidationRow} from "./dynamic-validation-row";
import {BlacklistRow} from "./blacklist-row";

export class ComponentValidation extends ComponentItems {
  public validationRows: DynamicValidationRow[] = [];
  public blacklistRows: BlacklistRow[];
}
